<template>
	<!-- 顶部导航区域 -->
    <section class="header">
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <div class="logo">
              <router-link to="/">
                <img src="@/assets/uupay/images/logo.png">
              </router-link>
            </div>
          </div>
          <div class="col-md-6 d-flex justify-content-center">
            <div>
              <el-menu :default-active="activeIndex" mode="horizontal" class="main-menu" 
                       text-color="#000" :router="true">
                <el-submenu index="1" popper-class="rounded-submenu">
                  <template #title>{{ $t('header.ourProduct') }}</template>
                  <el-menu-item index="/app" route>
                    <img class="submenu-icon" src="@/assets/uupay/icon/svg/grid.svg">
                    <!-- <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.66667 2H2V6.66667H6.66667V2Z" stroke="#21042E" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14 2H9.33333V6.66667H14V2Z" stroke="#21042E" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14 9.33333H9.33333V14H14V9.33333Z" stroke="#21042E" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.66667 9.33333H2V14H6.66667V9.33333Z" stroke="#21042E" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg> -->
                    <span slot="title">{{ $t('header.appProduct') }}</span>
                  </el-menu-item>
                  <el-divider></el-divider>
                  <el-menu-item index="/pos">
                    <!-- <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 3.33333C14 4.4379 11.3137 5.33333 8 5.33333C4.68629 5.33333 2 4.4379 2 3.33333M14 3.33333C14 2.22876 11.3137 1.33333 8 1.33333C4.68629 1.33333 2 2.22876 2 3.33333M14 3.33333V12.6667C14 13.7733 11.3333 14.6667 8 14.6667C4.66667 14.6667 2 13.7733 2 12.6667V3.33333M14 8C14 9.10666 11.3333 10 8 10C4.66667 10 2 9.10666 2 8" stroke="#21042E" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg> -->
                    <img class="submenu-icon" src="@/assets/uupay/icon/svg/database.svg">
                    <span slot="title">{{ $t('header.posProduct') }}</span>
                  </el-menu-item>
                  <el-divider></el-divider>
                  <el-menu-item index="/console">
                    <img class="submenu-icon" src="@/assets/uupay/icon/svg/monitor.svg">
                    <span slot="title">{{ $t('header.monitorProduct') }}</span>
                  </el-menu-item>
                </el-submenu>
                <el-menu-item index="/price">{{ $t('header.price') }}</el-menu-item>
                <el-submenu index="3" popper-class="rounded-submenu">
                  <template #title>{{ $t('header.resource') }}</template>
                  <el-menu-item index="/blogs">
                    <img class="submenu-icon" src="@/assets/uupay/icon/svg/book.svg">
                    <span slot="title">{{ $t('header.blog') }}</span>
                  </el-menu-item>
                  <el-divider></el-divider>
                  <el-menu-item index="3-2">
                    <img class="submenu-icon" src="@/assets/uupay/icon/svg/book_open.svg">
                    <span slot="title">{{ $t('header.document') }}</span>
                  </el-menu-item>
                  <el-divider></el-divider>
                  <el-menu-item index="3-3">
                    <img class="submenu-icon" src="@/assets/uupay/icon/svg/smile.svg">
                    <span slot="title">{{ $t('header.case') }}</span>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="4" popper-class="rounded-submenu">
                  <template #title>{{ $t('header.company') }}</template>
                  <el-menu-item index="4-1">
                    <img class="submenu-icon" src="@/assets/uupay/icon/svg/info.svg">
                    <span slot="title">{{ $t('header.aboutUs') }}</span>
                  </el-menu-item>
                  <el-divider></el-divider>
                  <el-menu-item index="4-2">
                    <img class="submenu-icon" src="@/assets/uupay/icon/svg/message_circle.svg">
                    <span slot="title">{{ $t('header.job') }}</span>
                  </el-menu-item>
                  <el-divider></el-divider>
                  <el-menu-item index="4-3">
                    <img class="submenu-icon" src="@/assets/uupay/icon/svg/headphones.svg">
                    <span slot="title">{{ $t('header.contactUs') }}</span>
                  </el-menu-item>
                  <el-divider></el-divider>
                  <el-menu-item index="4-4">
                    <img class="submenu-icon" src="@/assets/uupay/icon/svg/file.svg">
                    <span slot="title">{{ $t('header.news') }}</span>
                  </el-menu-item>
                </el-submenu>
              </el-menu>
            </div>
          </div>
          <div class="col-md-3 d-flex justify-content-end">
            <div class="action-button">
              <lang-select/>
              <div>
                <button class="now-use" @click="gotoDownload">{{ $t('header.toDownload') }}</button>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      <custom-dialog :visible.sync="download" width="500px"/>
    </section>
</template>

<script>
import LangSelect from '@/components/LangSelect'
import CustomDialog from "@/components/CustomDialog";

export default {
	name: 'UUPayHeader',
  components: { LangSelect, CustomDialog },
  data() {
    return {
      activeIndex: '1',
      activeNames: ['1'],
      download: false
    }
  },
  methods: {
    handleCommand(command) {
      console.log(command);
    },
    contactUs() {
      console.log('聯繫我們');
    },
    gotoDownload() {
      this.download = true
    }
  }
}
</script>

<style scoped>
	.submenu-icon {
	  margin: 0 0.5rem;
	}
	.submenu-title {
	  font-size: 12px;
	  line-height: 16px;
	}

	.header {
	  /*display: flex;
	  justify-content: space-between;
	  align-items: center;
	  background-color: #ffffff;
	  padding: 0 20px;
	  height: 70px;
	  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	  padding: 0 15rem;*/
    height: 70px;
	}

	.logo {
	  height: 70px;
    display: flex;
    align-items: center;
	}

	.main-menu {
	  border-bottom: none;
	  margin-left: auto;
	}

	.action-button {
	  display: flex;
	  justify-content: center;
	  align-items: center;
    height: 70px;
	}
	.header .now-use {
	  width: 110px;
	  height: 40px;
	  border-radius: 4px;
	  font-size: 12px;
	  line-height: 18px;
	  background-color: #9A307A;
	  color: #fff;
	  border: none;
    cursor: pointer;
	}
  .now-use:focus, .now-use:hover {
    outline: none;
    text-decoration: none;
    border: none;
  }
	.mobile-menu {
	  display: none;
	}
</style>


// WEBPACK FOOTER //
// src/layout/uupayHeader.vue